import { EditorialSnapshot } from './editorial';
// Explicit null overrides suppress a field; absent keys inherit the new source.
export function composeSourceContent(source: EditorialSnapshot, overrides: EditorialSnapshot): EditorialSnapshot {
  return { ...source, ...overrides };
}
